// ===================================================
// FOTOS — ESTOQUE (material)
// ===================================================
function renderEstoqueFotosGrid(){
  const grid = document.getElementById('est-fotos-grid');
  if(!grid) return;
  if(!_estoqueFotosTemp||!_estoqueFotosTemp.length){
    grid.innerHTML='<div style="color:var(--muted);font-size:12px;padding:8px 0">Nenhuma foto adicionada</div>';
    return;
  }
  grid.innerHTML = _estoqueFotosTemp.map((p,i)=>`
    <div style="position:relative;width:80px;height:80px;border-radius:8px;overflow:hidden;border:1px solid var(--border);flex-shrink:0" id="estfoto-${i}">
      <img src="" style="width:100%;height:100%;object-fit:cover" loading="lazy">
      <button onclick="estoqueFotoRemover(${i})" style="position:absolute;top:2px;right:2px;background:#f06595;color:#fff;border:none;border-radius:50%;width:18px;height:18px;font-size:11px;cursor:pointer;line-height:18px;padding:0">×</button>
    </div>`).join('');
  _estoqueFotosTemp.forEach((p,i)=>{
    dbxGetThumbnailUrl(p).then(url=>{
      const img = document.querySelector('#estfoto-'+i+' img');
      if(img&&url) img.src=url;
    }).catch(()=>{});
  });
}

function estoqueFotoRemover(i){
  _estoqueFotosTemp.splice(i,1);
  renderEstoqueFotosGrid();
}

async function estoqueUploadFoto(){
  if(!await dbxEnsureToken()){toast('Conecte o Dropbox primeiro','error');return;}
  const input=document.createElement('input');
  input.type='file';input.accept='image/*';input.multiple=true;
  input.onchange=async()=>{
    const files=[...input.files];
    if(!files.length) return;
    const matId=document.getElementById('est-id')?.value||'novo';
    const mesAno=new Date().toISOString().slice(0,7);
    const btn=document.getElementById('est-foto-btn');
    if(btn){btn.disabled=true;btn.textContent='⏳ Enviando...';}
    for(const file of files){
      const ext=file.name.split('.').pop()||'jpg';
      const ts=Date.now();
      const path=`/Estoque/Materiais/${mesAno}/${matId}_${ts}.${ext}`;
      try{
        const result=await dbxUploadFile(path,file);
        if(result&&!result.error_summary){
          _estoqueFotosTemp.push(path);
          renderEstoqueFotosGrid();
        } else { toast('Erro ao enviar foto','error'); }
      } catch(e){ toast('Erro no upload: '+e.message,'error'); }
    }
    if(btn){btn.disabled=false;btn.textContent='📷 Adicionar foto';}
  };
  input.click();
}

